import React, { type ReactNode, useEffect, useId } from 'react';

import { createPortal } from 'react-dom';

import { useAiTools } from './AiToolsContext';

interface Props {
  title: string;
  children: ReactNode;
}

/** Portal page-owned workflows into the sidebar without losing their form context. */
export default function AiToolsSection({ title, children }: Props) {
  const id = useId();
  const { isAvailable, container, registerSection } = useAiTools();

  useEffect(() => {
    if (isAvailable) {
      return registerSection({ id, title });
    }
    return undefined;
  }, [id, isAvailable, registerSection, title]);

  if (!isAvailable) {
    return <>{children}</>;
  }

  return container ? createPortal(children, container) : null;
}
